/**
 * The single public support contact used across the product.
 * Keep the legacy aliases so existing screens use the same verified address.
 */
export const SUPPORT_EMAIL = "globememories.business@gmail.com";
export const TECHNICAL_SUPPORT_EMAIL = SUPPORT_EMAIL;
export const GENERAL_SUPPORT_EMAIL = SUPPORT_EMAIL;
